

(() => {
  if (window.giraffePriceRangeInitialized) return;
  window.giraffePriceRangeInitialized = true;

  const selector = '[data-giraffe-price-range]';

  function initializePriceRange(container) {
    if (container.dataset.initialized === 'true') return;

    const sliderMin = container.querySelector('[data-price-slider-min]');
    const sliderMax = container.querySelector('[data-price-slider-max]');
    const inputMin = container.querySelector('[data-price-input-min]');
    const inputMax = container.querySelector('[data-price-input-max]');
    const progress = container.querySelector('.giraffe-price-range__progress');

    if (!sliderMin || !sliderMax || !inputMin || !inputMax) return;

    container.dataset.initialized = 'true';

    const limit = Number(container.dataset.priceMax) || 0;

    function clamp(value) {
      return Math.max(0, Math.min(limit, Number(value) || 0));
    }

    function updateProgress(min, max) {
      if (!progress) return;

      const left = limit ? (min / limit) * 100 : 0;
      const right = limit ? (max / limit) * 100 : 100;

      progress.style.left = `${left}%`;
      progress.style.width = `${right - left}%`;
    }

    function sync(source) {
      let min = clamp(
        source === 'input' ? inputMin.value : sliderMin.value
      );
      let max = clamp(
        source === 'input' ? inputMax.value : sliderMax.value
      );

      if (min > max) {
        if (source === 'min') {
          min = max;
        } else {
          max = min;
        }
      }

      sliderMin.value = min;
      sliderMax.value = max;
      inputMin.value = min;
      inputMax.value = max;

      updateProgress(min, max);
    }

    function applyFilter() {
      const form = container.closest('form');
      if (!form) return;

      // Dawnの既存フィルター処理へ変更を通知
      inputMin.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sliderMin.addEventListener('input', () => sync('min'));
    sliderMax.addEventListener('input', () => sync('max'));

    sliderMin.addEventListener('change', applyFilter);
    sliderMax.addEventListener('change', applyFilter);

    inputMin.addEventListener('change', () => {
      sync('input');
      applyFilter();
    });

    inputMax.addEventListener('change', () => {
      sync('input');
      applyFilter();
    });

    updateProgress(
      clamp(sliderMin.value),
      clamp(sliderMax.value)
    );
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initializePriceRange);
  }

  document.addEventListener('DOMContentLoaded', initializeAll);

  // DawnのAjax再描画後にも初期化
  const observer = new MutationObserver(initializeAll);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState !== 'loading') {
    initializeAll();
  }
})();